"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmail = void 0;

var isValidEmail = function isValidEmail(email) {
  return /^([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+)$/.test(email);
};

exports.isValidEmail = isValidEmail;